import { render } from "./adminHead.vue?vue&type=template&id=13569346&scoped=true"
import script from "./adminHead.vue?vue&type=script&lang=js"
export * from "./adminHead.vue?vue&type=script&lang=js"

import "./adminHead.vue?vue&type=style&index=0&id=13569346&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13569346"]])

export default __exports__